import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';

import Actions from '@app/store/action';
import Assets from '@app/assets';
import Helper from '@app/helper';
import I18n from '@module/i18n';
import TextField from '@component/form/element/textfield';
import Spinner from '@component/spinner';

import { VALIDATION_IDENTIFIERS } from '@app/constant/validation-identifiers';
import { WHITE } from '@app/constant/colors';

function ForceAccountVerification({ prePopulatedEmail }) {
  const dispatch = useDispatch();
  const [email, setEmail] = useState(prePopulatedEmail);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validState, setValidState] = useState(null);

  async function handleSubmit(event) {
    event.preventDefault();

    try {
      setIsSubmitting(true);
      setValidState(null);
      return await dispatch(
        Actions.User.resendVerifyAccountEmail({
          email,
          showTransferNotification: true,
        })
      );
    } catch {
      setValidState(VALIDATION_IDENTIFIERS.NOT_VALID);
    }

    setIsSubmitting(false);
  }

  const isSubmitButtonActive = Helper.validateEmail(email) && !isSubmitting;

  const submitButtonClassName = classnames(
    'transfer__button',
    'force-account-verification__submit',
    {
      'transfer__button--inactive': !isSubmitButtonActive,
    }
  );

  return (
    <form
      className="transfer__window force-account-verification"
      onSubmit={handleSubmit}
    >
      <div className="transfer__contents force-account-verification__contents">
        <img
          className="force-account-verification__lock"
          src={Assets.lookup('transfer_window/email-verification-lock.svg')}
          alt="Lock"
        />
        <h2 className="force-account-verification__title">
          {I18n.t('transfer.email-verification.title')}
        </h2>
        <p className="force-account-verification__body">
          {I18n.t('transfer.force-account-verification.body')}
        </p>
        <TextField
          name="force-verification-email__textfield"
          placeholder={I18n.t('transfer.email-verification-resend.email')}
          className="force-account-verification__textfield"
          inputClassName="force-account-verification__textfield-input"
          onChange={(event) => setEmail(event.target.value)}
          value={email}
          valid={validState}
        />
      </div>
      <div className="transfer__footer force-account-verification__footer">
        <button
          className={submitButtonClassName}
          onClick={handleSubmit}
          type="submit"
          disabled={!isSubmitButtonActive}
        >
          {isSubmitting ? (
            <Spinner
              rotate={true}
              percentage={25}
              hideText
              circumference={24}
              stroke={3}
              className="email-verification__spinner"
              foreground={WHITE}
            />
          ) : (
            I18n.t('transfer.force-account-verification.cta')
          )}
        </button>
      </div>
    </form>
  );
}

ForceAccountVerification.propTypes = {
  prePopulatedEmail: PropTypes.string.isRequired,
};

export default ForceAccountVerification;
